const FormatPriceNumeral = (price) => {
  if (price < 1000) return price.toLocaleString();
  /**
   * @returns Foramtted Price in String
   */
  price = parseInt(price);
  return price.toLocaleString();
};

export default FormatPriceNumeral;
